// Guest email gate for the chat widget (Tomer 25 Oct: "can it require non
// logged in users to enter email so we can get back to them?").
// Pure helpers so the rule is testable without a DOM. The server enforces the
// same rule (src/routes/chat.ts); this only spares the visitor a round trip.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export function isValidChatEmail(email) {
    const e = (email || '').trim();
    return e.length > 0 && e.length <= 254 && EMAIL_RE.test(e);
}
/**
 * Build the /api/chat/message body. When the session still needs an email
 * (a guest who has not given one), the email must be present and valid;
 * otherwise no email field is sent at all.
 */
export function buildMessagePayload(sessionId, content, emailRequired, email, name) {
    const text = (content || '').trim();
    if (!text)
        return { ok: false, error: 'EMPTY' };
    if (!emailRequired)
        return { ok: true, payload: { sessionId, content: text } };
    const e = (email || '').trim();
    if (!e)
        return { ok: false, error: 'EMAIL_REQUIRED' };
    if (!isValidChatEmail(e))
        return { ok: false, error: 'INVALID_EMAIL' };
    const n = (name || '').trim();
    return { ok: true, payload: { sessionId, content: text, email: e, ...(n ? { name: n } : {}) } };
}
export const EMAIL_ERROR_TEXT = {
    EMAIL_REQUIRED: 'Add your email first so we can reply if you step away.',
    INVALID_EMAIL: 'That email address does not look right.',
};
